import { useState } from 'react';
import './style.scss';

type Props = {
  onOpenChat: () => void;
  onClose: () => void;
  title?: string;
  titleAvatar?: string;
  subtitle?: string;
}

function NewLauncher({ onOpenChat, onClose, title, titleAvatar, subtitle }: Props) {
  const vkLink = process.env.VK_LINK || 'https://vk.com';
  const imageFull = process.env.IMAGE_FULL || titleAvatar;

  const handleOpenChat = (e: React.MouseEvent<HTMLDivElement>) => {
    // Проверяем, что клик не по кнопке закрытия
    const target = e.target as HTMLElement;
    const clickedCloseButton = target.closest('.rcw-new-launcher-btn-close');
    if (clickedCloseButton) {
      return;
    }
    
    // Вызываем onOpenChat для открытия виджета
    onOpenChat();
    
    // Закрываем промежуточное окно
    onClose();
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  const handleVkClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(vkLink, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="rcw-new-launcher-container">
      <a
        href={vkLink}
        target="_blank"
        rel="noopener noreferrer"
        className="rcw-new-launcher-btn-vk"
        onClick={handleVkClick}
      >
        MAX
      </a>
      <div 
        className="rcw-new-launcher" 
        onClick={handleOpenChat}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleOpenChat(e as any);
          }
        }}
      >
        <div className="rcw-new-launcher-content">
          <button 
            className="rcw-new-launcher-btn-close" 
            onClick={handleClose}
            type="button"
            aria-label="Закрыть"
          >
            <span>×</span>
          </button>
          {imageFull && (
            <img className="rcw-new-launcher-img" src={imageFull} alt={title || 'Avatar'} />
          )}
          {title && (
            <div className="rcw-new-launcher-label">
              {title}
            </div>
          )}
          <div className="rcw-new-launcher-title">
            <div className="rcw-new-launcher-title-status"></div>
            <div className="rcw-new-launcher-title-content">
              {subtitle || 'Начать диалог'}
            </div>
          </div>
          <div className="rcw-new-launcher-bottom-img-cropper"></div>
        </div>
      </div>
    </div>
  );
}

export default NewLauncher;

